module.exports = __webpack_public_path__ + "static/media/KGPrimaryDotsLined.0e635851.ttf";